<template>
  <div>$END$</div>
</template>

<script>
export default {
  name: 'PCDialog'
}
</script>

<style scoped>

</style>
